import { ColumnId, PortGroupingType } from '@discngine/moosa-models';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IDecisoinTreeConfigState } from './types';

const initialState: IDecisoinTreeConfigState = {
  columnGroupId: null,
  defaultPortGrouping: PortGroupingType.Regular,
  dateColumnId: null,
  dateFormat: undefined,
};

export const decisionTreeConfigSlice = createSlice({
  name: 'decisionTreeConfig',
  initialState,
  reducers: {
    resetDecisionTreeConfig(state) {
      state.columnGroupId = initialState.columnGroupId;
      state.defaultPortGrouping = initialState.defaultPortGrouping;
      state.dateColumnId = initialState.dateColumnId;
      state.dateFormat = initialState.dateFormat;
    },
    setDecisionTreeGroupColumnId(state, action: PayloadAction<ColumnId | null>) {
      state.columnGroupId = action.payload;
    },
    setDecisionTreeDateColumnId(state, action: PayloadAction<ColumnId | null>) {
      state.dateColumnId = action.payload;
    },
    setDecisionTreeDateFormat(state, action: PayloadAction<string | undefined>) {
      state.dateFormat = action.payload;
    },
    setDecisionTreeDefaultPortGrouping(
      state,
      action: PayloadAction<PortGroupingType | null>
    ) {
      state.defaultPortGrouping = action.payload;
    },
  },
});

export const {
  resetDecisionTreeConfig,
  setDecisionTreeGroupColumnId,
  setDecisionTreeDefaultPortGrouping,
  setDecisionTreeDateColumnId,
  setDecisionTreeDateFormat,
} = decisionTreeConfigSlice.actions;
